<template>
  <!-- 组织机构  -->
  <div class="second-page-wrapper">
    <div class="second-page-wrapper-left">
      <com-slide :slideList="titleList"></com-slide>
    </div>
    <div class="second-page-wrapper-right">
      <router-view></router-view>
    </div>
  </div>
</template>
<style scoped>
.second-page-wrapper {
  width: 1230px;
  margin: 0 auto 30px;
  display: flex;
}
.second-page-wrapper-left{
   width: 310px;
  margin-right: 30px;
}
.second-page-wrapper-right{
  width: 890px;
}
</style>

<script>
import comSlide from "./slide.vue";
export default {
  data() {
    return {
      titleList: [
        // {
        //   title: "专题活动",
        //   section: "1"
        // },
        {
          title: "党建动态",
          section: "2"
        },
         {
          title: "党风廉政",
          section: "3"
        },
         {
          title: "群团建设",
          section: "4"
        },
         {
          title: "图片新闻",
          section: "5"
        },
      ]
    };
  },
  components: {
    comSlide
  }
};
</script>




// WEBPACK FOOTER //
// src/components/views/ComParty/index.vue